import ProgressBar from 'progressbar.js';


function setPercentageProgress(state, bar, opt) {
  return Math.round(bar.value() * 100) + ' ' + opt.unit;
}

function setActualProgress(state, bar, opt) {
  return Math.round(bar.value() * opt.maxValue) + ' ' + opt.unit;
}

$(function () {

  $('.js-progress-bar').each((index, el) => {

    let data = $(el).data(),
      updateCallback,
      mergedOptions = {},
      defaultOptions = {
        unit: '%',
        duration: 1400,
        color: '#333333'
      },
      bar;

    for (let x in data) {
      if (data && data.hasOwnProperty(x) && data[x]) {
        mergedOptions[x] = data[x];
      } else {
        mergedOptions[x] = defaultOptions[x];
      }
    }

    if (mergedOptions.unit === '%') {
      updateCallback = setPercentageProgress;
    } else {
      updateCallback = setActualProgress;
    }

    bar = new ProgressBar.Line(el, {
      strokeWidth: 4,
      easing: 'easeInOut',
      duration: mergedOptions.duration,
      color: mergedOptions.color,
      trailColor: 'transparent',
      trailWidth: 1,
      svgStyle: {width: '100%', height: '100%'},
      text: {
        style: {
          // Text color.
          // Default: same as stroke color (options.color)
          color: 'inherit'
        },
        autoStyleContainer: false
      },
      from: {color: '#FFEA82'},
      to: {color: '#ED6A5A'},
      step: (state, bar) => {
        let value = updateCallback.apply(this, [state, bar, mergedOptions]);
        bar.setText(value);
        bar.text.style.left = bar.value() * 100 + '%';
      }
    });

    if (mergedOptions.minValue) {
      bar.set(data.minValue / data.maxValue);
    }

    $(el).one('inview', function (event, visible) {
      event.stopPropagation();
      bar.animate(data.targetValue / data.maxValue);
    });

  });
});



// WEBPACK FOOTER //
// ./src/js/modules/progress-bars.js